import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import Reveal from "@/components/Reveal";
import ZigzagDivider from "@/components/ZigzagDivider";

const CtaBand = () => (
  <section id="contact" className="relative overflow-hidden" data-testid="cta-band">
    <ZigzagDivider fill="#25414f" flip className="bg-white" />
    <div className="relative bg-petrol">
      <div className="blueprint-grid absolute inset-0" aria-hidden="true" />
      <div className="relative mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-10 px-5 py-20 md:px-10 md:py-28">
        <Reveal>
          <p className="mb-3 text-xs uppercase tracking-[0.3em] text-copperlight md:text-sm">
            Free quotes · No obligation
          </p>
          <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white md:text-6xl">
            Got a job
            <br />
            on the go?
          </h2>
          <p className="mt-6 max-w-md text-base leading-relaxed text-white/70 md:text-lg">
            Send through the details and Derek will come back with a straight
            answer and a fair price.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="flex flex-col flex-wrap gap-4 sm:flex-row sm:items-center">
          <Link
            to="/quote"
            data-testid="cta-quote-button"
            className="group flex items-center justify-center gap-2 bg-copper px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink transition-colors hover:bg-white"
          >
            Request a Quote
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
          </Link>
          <a
            href="tel:0490425408"
            data-testid="cta-call-button"
            className="flex items-center justify-center gap-2 border-2 border-white/40 px-8 py-4 text-sm uppercase tracking-[0.15em] text-white transition-colors hover:border-copper hover:text-copper"
          >
            <Phone className="h-4 w-4" strokeWidth={1.5} />
            0490 425 408
          </a>
          <a
            href="mailto:exchange.electrical@gmail.com"
            data-testid="cta-email-link"
            className="text-center text-xs uppercase tracking-[0.2em] text-white/50 transition-colors hover:text-copper sm:basis-full sm:text-left"
          >
            exchange.electrical@gmail.com
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default CtaBand;
